import FiltersComponent from './Filters.vue';
import FiltersMobile from './FiltersMobile.vue';
import { createVueApp } from '@/src/vue/utils/createVueApp';

export function useFiltersComponent (isMobile = false) {
	const component = isMobile ? FiltersMobile : FiltersComponent;

	const FiltersApp = createVueApp(component, {});

	// Register filter components
	const filterComponents = import.meta.glob('./*.vue', { eager: true });
	Object.entries(filterComponents).forEach(([path, definition]) => {
	// Get name of component, based on filename
		const componentName = path.split('/').pop().replace(/\.\w+$/, '');

		// Register component on this Vue instance
		FiltersApp.component(componentName, definition.default);
	});


	return FiltersApp;
}
